import { ProductCategory } from '../types/shared/products.js';

const mapProductTypeToProductCategory = (productType)=>{
    switch(productType === null || productType === void 0 ? void 0 : productType.toLowerCase()){
        case 'ready-readers':
        case 'frames':
        case 'optical':
        case 'non-prescription-bundle':
        case 'prescription-glasses':
            return ProductCategory.OPTICS;
        case 'sunglasses':
            return ProductCategory.SUN;
        case 'contact-lenses':
            return ProductCategory.CONTACT_LENSES;
        case 'accessories':
        case 'solutions':
            return ProductCategory.ACCESSORIES;
        default:
            return ProductCategory.EYEWEAR;
    }
};

export { mapProductTypeToProductCategory };
//# sourceMappingURL=map-product-type-to-product-category.js.map
